<template>
	<div class="item-card">
		<div class="item-heart single-link" :class="{ 'item-heart-active': render_is_favorite }" @click="toggleFavorite(user, render_product)"></div>
		<span class="item-card-discount item-card-new-margin"
			v-bind:class="{ 'item-card-new-margin-discount': render_product.is_novedad }"
			v-if="parseInt(render_product.discount_percentage)">
				{{ parseInt(render_product.discount_percentage) }}%
			</span>
			<img class="item-card-new" v-if="render_product.is_novedad" src="../../images/nuevo.png" alt="nuevo">

<!-- required for making entire div clickable-->
		<a class='full-link' v-link="{ path: '/product/' + convertToUrl(render_product) }">{{ render_product.name }}></a>
<!-- -->
		<img class="img-responsive product-image center-block" :src="render_image || image" alt="prod">
		<span class="single-link over"><a class="item-card-name" v-link="{ path: '/product/' + convertToUrl(render_product) }">{{ render_product.name }}</a></span>
    <div class="item-card-shipping-wrap">
      <div class="item-card-shipping" v-if="product.volume === 0">Envío Gratis</div>
    </div>
    <div class="item-card-bot">
      <span class="fa-stack fa-lg single-link" :class="{ 'disabled': render_product.stock == 0 }" style="float: right;">
        <i class="fa fa-circle fa-stack-2x"></i>
        <i class="fa fa-shopping-cart fa-stack-1x fa-inverse" @click="addProduct(user, render_product)"></i>
      </span>
      <div class="item-rate">
        <input type="hidden" class="rating" data-filled="fa fa-star item-rate-yellow item-rate" data-empty="fa fa-star item-rate-gray item-rate" data-readonly :value="render_product.rating"/>
      </div>
      <div class="frow fbottom">
        <span class="item-gray line-throught" v-if="parseInt(render_product.discount_percentage)">${{ accounting.formatMoney(render_product.original_price, '') }} </span>
        <span class="item-blue">${{ accounting.formatMoney((render_product.original_price - (render_product.original_price * (render_product.discount_percentage / 100))).toFixed(2), '') }} </span>
      </div>
    </div>
	</div>
</template>

<script>
import API from '../../store/api';
import { api_base } from '../../store/api';
import default_image from '../../images/default.jpg';
import { toast } from '../../scripts/toast';
import { convertToUrl } from '../../scripts/convert_name';
import accounting from '../../scripts/accounting';
import {
	addProductShoppingCart,
	addProductWishList,
	removeProductWishList
} from '../../store/actions';

export default {
	props: ['product'],

	data() {
		return {
			image: default_image,
			is_favorite: false,
			accounting
		};
	},

	vuex: {
		getters: {
			color: state => state.color,
			user: state => state.current_user,
			wish_list: state => state.wish_list
		},
		actions: {
			addProductShoppingCart,
			addProductWishList,
			removeProductWishList
		}
	},

	methods: {
		getProductImg() {
			API.Products.getImg(this.product.id, this.getImg);
		},

		addProduct (user, product) {
			if (product.stock != 0) {
				return this.addProductShoppingCart(user, product);
			}

			toast({
				title: 'Carrito de Compras',
				content: 'Producto agotado.'
			});
		},

		getImg(res) {
			this.image = res;
		},

		toggleFavorite(user, product) {
			if (this.is_favorite) {
				this.removeProductWishList(user, product);
			} else {
				this.addProductWishList(user, product);
			}
		},

		getImageInBaseColor(product) {
			if (this.color === product.color || !this.color) {
				return product.images[0].route;
			} else {
				for (let i = 0, c = product.childs; i < c.length; i++) {
					if (this.color === c[i].color) {
						return c[i].images[0].route;
					}
				}
			}
		},

		convertToUrl
	},

	computed: {
		render_product() {
			return this.product;
		},

		render_image() {
			if (this.product.images && this.product.images.length) {
				return this.getImageInBaseColor(this.product);
			}
		},

		render_is_favorite() {
			for (var i = 0; i < this.wish_list.length; i++) {
				if (this.product.id == this.wish_list[i].product_id) {
					this.is_favorite = true;
					return true;
				}
			}

			this.is_favorite = false;
			return false;
		}
	},

	ready() {
		$('.rating').rating();
		// this.getProductImg();
	}
}
</script>



// WEBPACK FOOTER //
// Card.vue?db3b26e2